var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3272 13.3015L4.19021 20.7643C3.23676 21.4032 2 20.6682 2 19.4628V4.53724C2 3.33177 3.23675 2.59684 4.19021 3.23574L15.3272 10.6985C16.2243 11.2996 16.2243 12.7004 15.3272 13.3015Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4C18 3.44772 18.4477 3 19 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H19C18.4477 21 18 20.5523 18 20V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.178ba82272d328c45226323931f105c7.svg";
export { ForwardRef as ReactComponent };